<template>
  <div
    class="page-aside-block"
    :id="id"
  >
    <div class="page-aside-title" ref="block">{{blockTitle}}</div>
    <div class="page-aside-cards">
     <template v-for="(card, item) of cards">
        <div class="aside-card" :key="item" ref="card">
          <template v-if="!card.static">
            <a href="javascript:void(0);" class="aside-card-header" role="button" :class="{expand: expand[item]}" @click="onExpand(item)">
              <div class="aside-card-header-text" v-html="card.title"></div>
              <div class="aside-card-header-trigger" :class="{expand: expand[item]}"></div>
            </a>
  
            <slide-toggle :expanded="expand[item]">
              <div class="aside-card-body-text" ref="cardBodyText">
                <div v-if="card.text" v-html="card.text"></div>
              </div>
            </slide-toggle>
          </template>
          <template v-if="card.static">
            <div class="aside-card-body-text" ref="cardBodyText">
              <div v-if="card.text" v-html="card.text"></div>
            </div>
          </template>
        </div>
     </template>
    </div>
  </div>
</template>
<script>
import SlideToggle from "@/components/functional/SlideToggle";
export default {
  name: "aside-info-block",
  props: {
    id: String,
    blockTitle: String,
    cards: {
      card: {
        expanded: Boolean,
        title: String,
        text: String
      }
    }
  },
  data() {
    return {
      expand: [],
    }
  },
  watch: {
    isExpand() {
      this.expand = this.isExpand;
      const index = this.expand.findIndex(el => el)
      if (index > 0) {
        this.scrollToExpand(index)
      }
    },
    expandedItem() {
      this.onExpand(this.expandedItem);
      if (this.expandedItem) {
        this.$refs["card"][this.expandedItem].scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }      
    }
  },
  computed: {
    isExpand() {         
      return this.cards.map(el => {
        return el.expanded;
      });
    }
  },
  methods: {
    setAllCollapsed() {
      this.expand = this.cards.map(() => {
        return false
      })
    },
    scrollToExpand(i) {
      setTimeout(() => {
        this.expand[i] ? this.$refs["card"][i].scrollIntoView({ block: "start", behavior: "smooth" }) : this.$refs.block.scrollIntoView({ block: "start", behavior: "smooth" })
      }, 400);
    },
    onExpand(i) {
      if (!this.expand[i]) {
        this.setAllCollapsed()
        this.expand[i] = true;
      } else {
        this.setAllCollapsed()
        this.$emit('collapsed', i)
      }
      this.scrollToExpand(i)
    }
  },
  components: {
    SlideToggle
  },
  mounted() {
    this.expand = this.isExpand;
  }
};
</script>
